import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

// GET: Fetch investments for profile summary
// export const getProfileSummaryInvestments = createAsyncThunk(
//     "filtersDropdown/getProfileSummaryInvestments",
//     async ({ id, from, search ,clientId,advisorId}, { rejectWithValue }) => {
//         try {

//             let queryParams = '';
//             if (from === "withClient" && id) {
//                 queryParams += `?client_id=${id}`;
//             }
//             if (id && from !== "withClient") {
//                 queryParams += `?account_type=${id}`;
//             }
//             if(clientId){
//                 queryParams+=`?clientId=${clientId}`
//             }
//             if(advisorId){
//                 queryParams+=`?advisorId=${advisorId}`
//             }
//             if (search) {
//                 queryParams += `${queryParams ? "&" : "?"}search=${search}`;
//             }
//             const url = `/profileSummary/getInvestments${queryParams.toString() ? `${queryParams.toString()}` : ''}`;

//             const response = await getMethod(url);
//             const data = await response.json();
//             if (!response.ok) {
//                 throw new Error(data?.message || "Failed to fetch investments");
//             }
//             return data;
//         } catch (error) {
//             console.error("Error fetching investments:", error);
//             return rejectWithValue(error?.message || "Failed to fetch investments");
//         }
//     }
// );

export const getProfileSummaryInvestments = createAsyncThunk(
    "filtersDropdown/getProfileSummaryInvestments",
    async ({ id, from, search, clientId,accountId, advisorId }, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams();

            if (from === "withClient" && id) {
                params.append("clientId", id);
            } else if (id && from !== "withClient") {
                params.append("productId", id);
            }
            if (clientId) params.append("clientId", clientId);
            if (accountId) params.append("accountId", accountId);
            if (advisorId) params.append("advisor_id", advisorId);
            if (search) params.append("search", search);

            const queryString = params.toString();
            const url = `/profileSummary/getInvestments${queryString ? `?${queryString}` : ""}`;

            const response = await getMethod(url);
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "Failed to fetch investments");
            }

            return data;
        } catch (error) {
            return rejectWithValue(error?.message || "Failed to fetch investments");
        }
    }
);


export const getSecuritiesWithId = createAsyncThunk(
  "filtersDropdown/getSecuritiesWithId",
  async (
    { id, advisorId, accountId, investmentId, search },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();

      if (id) params.append("clientId", id);
      if (advisorId) params.append("advisorId", advisorId);
      if (accountId) params.append("accountId", accountId);
      if (investmentId) params.append("investmentId", investmentId);
      if (search) params.append("search", search);

      const query = params.toString();
      const url = `/profileSummary/getSecurities${query ? `?${query}` : ""}`;

      const response = await getMethod(url);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Failed to fetch securities");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch securities");
    }
  }
);

export const getAdvisorSecuritiesWithId = createAsyncThunk(
    "filtersDropdown/getAdvisorSecuritiesWithId",
    async ({ id, advisorId, search }, { rejectWithValue }) => {
        try {
            let queryParams = '';
            if (id) queryParams += `?clientId=${id}`;
            if (advisorId) queryParams += `${queryParams ? '&' : '?'}advisorId=${advisorId}`;
            if (search) {
                queryParams += `${queryParams ? "&" : "?"}search=${search}`;
            }
            const response = await getMethod(`/profileSummary/getSecurities${queryParams}`);
            const data = await response.json();
            return data;

        }
        catch (error) {
            console.error("Error fetching securities:", error);
            return rejectWithValue(error?.message || "Failed to fetch securities");
        }
    }
)


// Initial State
const initialState = {
    investments: [],
    loading: false,
    error: null,
    success: false,
    pagination: {},
    securities: [],
    getAdvisorsecurities: []

};

// Slice
const filtersDropdownSlice = createSlice({
    name: "filtersDropdown",
    initialState,
    reducers: {
        clearInvestmentsState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.investments = [];
            state.pagination = {};
        },
        resetFiltersDropdown: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.investments = [];
            state.pagination = {};
        },
    },
    extraReducers: (builder) => {
        builder
            // Get Profile Summary Investments
            .addCase(getProfileSummaryInvestments.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.investments = []; // Clear old data
                state.pagination = {}; // Clear old pagination
            })
            .addCase(getProfileSummaryInvestments.fulfilled, (state, action) => {
                state.loading = false;
                state.investments = action.payload.data || action.payload.investments || [];
                state.pagination = action.payload.pagination || {};
                state.success = true;
            })
            .addCase(getProfileSummaryInvestments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
                state.investments = [];
                state.pagination = {};
            })
            .addCase(getSecuritiesWithId.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.securities = []; // Clear old data
            })
            .addCase(getSecuritiesWithId.fulfilled, (state, action) => {
                state.loading = false;
                state.securities = action.payload.data || action.payload.securities || [];
                state.success = true;
            })
            .addCase(getSecuritiesWithId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
                state.securities = [];
            })
            .addCase(getAdvisorSecuritiesWithId.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.getAdvisorsecurities = [];
            })
            .addCase(getAdvisorSecuritiesWithId.fulfilled, (state, action) => {
                state.loading = false;
                state.getAdvisorsecurities = action.payload.data || action.payload.securities || [];
                state.success = true;
            })
            .addCase(getAdvisorSecuritiesWithId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
                state.getAdvisorsecurities = [];
            });
    },
});

export const { clearInvestmentsState, resetFiltersDropdown } = filtersDropdownSlice.actions;

export default filtersDropdownSlice.reducer;
